import { EffectBase } from "././EffectBase";
import { Tween } from "../tween/Tween";
import { Ease } from "../tween/Ease";
export class FadeIn extends EffectBase {
    _doTween() {
        this.target.alpha = 0;
        return Tween.to(this.target, { alpha: 1 }, this.duration, Ease[this.ease], this._comlete, this.delay);
    }
}
